<template>
    <div>
        <v-toolbar app color="black" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img
                    class="menuLogo ml-0"
                    src="../assets/images/Logo.png"
                    style="height: 45px"
                    @click="gotoHome()"
                />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout
                v-if="isDesktopMode()"
                align-start
                row
                justify-center
                class="red darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"
                ><span class="white--text"
                    ><strong>{{ nomeGara }}</strong> | Live |
                    <v-icon small>people</v-icon
                    ><small class="ml-1">{{ itemsF.length }}</small>
                </span>
            </v-layout>
            <v-spacer></v-spacer>
            <v-icon class="mr-2" @click="filterToggle = !filterToggle"
                >search</v-icon
            >
            <v-icon @click="downloadCsv()">download</v-icon>
            <span v-if="isMobileMode()">
                <v-icon v-if="!compatta" @click="compatta = !compatta"
                    >compress</v-icon
                >
                <v-icon v-else @click="compatta = !compatta">expand</v-icon>
            </span>
        </v-toolbar>

        <v-layout align-start row wrap justify-center class="mt-4">
            <v-flex v-if="filterToggle" flex xs12 sm6 md6 lg6>
                <v-text-field
                    style="padding: 3px; color: white; background-color: white"
                    v-model="searchText"
                    label="Cerca Cognome, team o pettorale"
                    outline
                    clearable
                    append-icon="search"
                    @input="changedSearch"
                ></v-text-field>
            </v-flex>
            <v-flex v-if="filterToggle" flex xs12 sm6 md6 lg6 class="mb-4">
                <v-select
                    style="padding: 5px; color: white; color: black"
                    :items="listaCategorie"
                    v-model="categoriaSelected"
                    :label="'Categoria'"
                    single-line
                    persistent-hint
                    :hint="'Categoria'"
                    @input="changedLabel"
                ></v-select>
            </v-flex>
            <v-flex
                flex
                xs12
                sm12
                md12
                lg12
                :class="isDesktopMode() ? 'sticky' : 'sticky-mobile'"
            >
                <v-layout
                    align-start
                    row
                    justify-center
                    class="white p-0 ml-0 mr-0"
                    ><span
                        ><strong>Classifica </strong> | Generale |
                        <v-icon small class="black--text">people</v-icon
                        ><small class="ml-1">{{ running }}</small>
                    </span>
                </v-layout>
            </v-flex>
            <v-flex
                flex
                xs12
                sm6
                md6
                lg6
                v-if="message !== undefined"
                class="mt-3 p-3 red darken-4 white--text text-xs-center"
            >
                <h3>{{ message }}</h3>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 v-if="message === undefined">
                <v-data-table
                    :items="itemsF"
                    hide-actions
                    hide-headers
                    class="elevation-1 mb-5"
                    style="width: 100%"
                >
                    <template slot="items" slot-scope="props">
                        <tr
                            v-if="isDesktopMode()"
                            style="height: 20px"
                            class="mb-0"
                        >
                            <td class="pa-0">
                                <table
                                    style="color: black; width: 100%"
                                    class="mb-3"
                                >
                                    <tr>
                                        <td
                                            colspan="11"
                                            class="cardUp pa-1"
                                            style=""
                                        >
                                            <strong
                                                style="
                                                    float: left;
                                                    margin: -4px;
                                                    background-color: orange;
                                                    color: black;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 4px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                "
                                            >
                                                {{ props.item.pos }}
                                            </strong>
                                            <strong
                                                style="float: left"
                                                class="ml-3"
                                            >
                                                <country-flag
                                                    :country="
                                                        props.item.nazione
                                                    "
                                                    size="small"
                                                />
                                                {{ props.item.cognome }}
                                                {{ props.item.nome }}
                                            </strong>
                                            <span class="ml-2">
                                                [ {{ props.item.categoria }} ]
                                            </span>
                                            <span
                                                ><small
                                                    class="white--text ml-2"
                                                >
                                                    {{
                                                        props.item.squadra
                                                    }}</small
                                                ></span
                                            >
                                            <strong
                                                style="
                                                    float: right;
                                                    margin: -4px;
                                                    background-color: lightgrey;
                                                    color: black;
                                                    border-radius: 0px 10px 0px
                                                        0px;
                                                    padding: 3px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                "
                                            >
                                                {{ props.item.divisione }}
                                            </strong>

                                            <small>
                                                <span
                                                    class="mr-3"
                                                    style="
                                                        float: right;
                                                        color: white;
                                                    "
                                                    >{{ props.item.data }}</span
                                                >
                                            </small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            class="frazioniValue"
                                            @click="
                                                gotoMappa(
                                                    props.item.idAttivita,
                                                    props.item.token
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/images/drone.png"
                                                width="30px"
                                            />
                                        </td>
                                        <td class="frazioniTitle">Tempo</td>
                                        <td class="frazioniTitleFinale">
                                            <strong>{{
                                                props.item.durata
                                            }}</strong>
                                        </td>
                                        <td class="frazioniTitle">Media</td>
                                        <td class="frazioniValue">
                                            <strong>{{
                                                props.item.media
                                            }}</strong>
                                        </td>
                                        <td class="frazioniTitle">Distanza</td>
                                        <td class="frazioniValue">
                                            <strong>{{
                                                props.item.lunghezza
                                            }}</strong>
                                        </td>
                                        <td class="frazioniTitle">
                                            Dislivello
                                        </td>
                                        <td class="frazioniValue">
                                            <strong
                                                >+{{
                                                    props.item
                                                        .dislivelloPositivo
                                                }}/{{
                                                    props.item
                                                        .dislivelloNegativo
                                                }}</strong
                                            >
                                        </td>
                                    </tr>
                                    <tr v-if="!compatta">
                                        <td
                                            colspan="8"
                                            class="frazioniValue"
                                            @click="
                                                gotoMappa(
                                                    props.item.idAttivita,
                                                    props.item.token
                                                )
                                            "
                                        ></td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr
                            v-if="isMobileMode()"
                            style="height: 20px"
                            class="mb-2"
                        >
                            <td class="pa-0">
                                <table
                                    style="color: black; width: 100%"
                                    class="mb-3 p-0"
                                >
                                    <tr class="p-0">
                                        <td
                                            colspan="3"
                                            class="cardUp pa-1"
                                            style=""
                                        >
                                            <strong
                                                class="mr-2"
                                                style="
                                                    float: left;
                                                    margin: -4px;
                                                    background-color: orange;
                                                    color: black;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 3px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                "
                                            >
                                                {{ props.item.pos }}
                                            </strong>
                                            <strong style="float: left">
                                                <country-flag
                                                    :country="
                                                        props.item.nazione
                                                    "
                                                    size="small"
                                                />
                                                {{ props.item.cognome }}
                                                {{ props.item.nome }}
                                            </strong>
                                            <small
                                                class="ml-3 white--text"
                                                style="float: right"
                                            >
                                                {{ props.item.data }}
                                            </small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="frazioniTitle">Tempo</td>

                                        <td class="frazioniTitle no-wrap">
                                            Media
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="frazioniTitleFinale">
                                            <strong>{{
                                                props.item.durata
                                            }}</strong>
                                        </td>

                                        <td class="frazioniValue">
                                            <strong>{{
                                                props.item.media
                                            }}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="frazioniValue">
                                            <v-btn
                                                small
                                                round
                                                @click="
                                                    gotoMappa(
                                                        props.item.idAttivita,
                                                        props.item.token
                                                    )
                                                "
                                            >
                                                <img
                                                    src="../assets/images/drone.png"
                                                    width="40px"
                                                />
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr v-if="!compatta">
                                        <td class="frazioniTitle">Distanza</td>
                                        <td class="frazioniValue">
                                            <strong
                                                >{{
                                                    props.item.lunghezza
                                                }}
                                                Km</strong
                                            >
                                        </td>
                                    </tr>
                                    <tr v-if="!compatta">
                                        <td class="frazioniTitle">
                                            Dislivello
                                        </td>
                                        <td class="frazioniValue">
                                            <strong
                                                >+{{
                                                    props.item
                                                        .dislivelloPositivo
                                                }}/{{
                                                    props.item
                                                        .dislivelloNegativo
                                                }}</strong
                                            >
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-footer
            v-if="isMobileMode()"
            fixed
            class="grey darken-2"
            style="height: 30px; padding: 10px"
        >
            <v-layout
                align-start
                row
                wrap
                justify-center
                class="red darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"
                ><span class="white--text"
                    ><strong>{{ nomeGara }}</strong> | Live |
                    <v-icon small class="white--text">people</v-icon
                    ><small class="ml-1">{{ itemsF.length }}</small>
                </span>
            </v-layout>
        </v-footer>
    </div>
</template>

<script>
import helper from '../helper';
const moment = require('moment');

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            compatta: true,
            checkpointSelected: 'TUTTI',
            listaCheckpoints: ['TUTTI'],
            categoriaSelected: 'TUTTE',
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            nomeGara: '',
            sponsor: null,

            connection: null,

            myInterval: null,
            sport: '',

            popup: false,
            currentItem: undefined,

            evento: {},
            configurazione: {},
            message: undefined,
            running: 0,
        };
    },

    beforeCreate() {},

    created() {},

    beforeDestroy() {
        //console.log('beforeDestroy:');
        clearInterval(this.myInterval);
    },

    mounted() {
        //console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.sponsor = this.$route.params.sponsor;

        var pref = helper.ls.get('PREFERITI_' + this.$route.params.raceID);
        //console.log('Preferiti:' + JSON.stringify(pref));
        if (pref == undefined) {
            helper.ls.set('PREFERITI_' + this.$route.params.raceID, {});
            this.listaPreferiti = {};
        } else {
            this.listaPreferiti = pref;
        }

        this.loadEvento();
    },

    computed: {
        descriptionById: function () {
            return (id) => this.isChecked(id);
        },
    },

    methods: {
        closePopup() {
            this.popup = false;
            this.currentItem = undefined;
        },
        openPopup(item) {
            this.currentItem = item;
            this.popup = true;
        },
        percentuale(numCP) {
            let p = numCP / (this.listaCheckpoints.length - 1);
            ////console.log(Math.ceil(p * 100));
            return Math.ceil(p * 100);
        },
        orarioPassaggio(orario) {
            return moment(orario).format('HH:mm:ss');
        },
        diffPassaggio(orario) {
            let momT = moment(orario);
            let now = moment(new Date());

            var diff = moment
                .utc(moment.duration(now - momT).asMilliseconds())
                .format('HH:mm');

            return diff + ' ore fa';
        },
        tempoPassaggio(cp, index) {
            //console.log('Index:' + index);
            if (index > 0) {
                let momT0 = moment(cp[index - 1].orarioPassaggio);
                let momT1 = moment(cp[index].orarioPassaggio);

                var diff = moment
                    .utc(moment.duration(momT1 - momT0).asMilliseconds())
                    .format('HH:mm');

                return diff;
            } else {
                return 'Partenza';
            }
        },
        changedLabel(event) {
            //console.log('Changed:' + event);
            this.checkpointSelected = event;

            this.itemsF = this.filteredList();
        },
        changedSearch(event) {
            //console.log('Changed:' + event);
            this.searchText = event;

            this.itemsF = this.filteredList();
        },
        isChecked(pett) {
            //console.log('is checked');
            return (
                this.listaPreferiti[pett] !== undefined &&
                this.listaPreferiti[pett] == pett
            );
        },

        loadEvento() {
            this.getEventoIcron(this.raceID).then((response) => {
                //console.log('getEventoIcron:');
                if (response.evento) {
                    this.evento = response.evento;
                    this.nomeGara = response.evento.descrizione;
                    this.configurazione = response.mappaConfigurazioni;
                }
                this.refresh(this);

                this.myInterval = setInterval(this.refresh, 10000, this);
            });
        },

        showClassifica(data) {
            this.raceData = data;
            if (this.raceData) {
                let lista = this.raceData.elencoPartecipanti;
                var pos = 1;
                lista.forEach((p) => {
                    p.pos = pos++;
                    if (p.durata.length > 8) {
                        p.durata = p.durata.substring(0, 8);
                    }
                    if (p.lunghezza) {
                        p.lunghezza =
                            Math.round(
                                (p.lunghezza / 1000 + Number.EPSILON) * 100
                            ) / 100;
                    }
                });

                this.running = pos - 1;

                if (this.filterPreferiti) {
                    this.items = lista.filter((item) => {
                        return this.listaPreferiti[item.Pett] !== undefined;
                    });
                } else {
                    this.items = lista;
                }

                this.listaCategorie = this.raceData.elencoPartecipanti
                    .map((item) => {
                        return item.categoria;
                    })
                    .sort();
                this.listaCategorie.unshift('TUTTE');

                this.itemsF = this.filteredList();
            }
        },

        gotoHome() {
            this.$router.push('/');
        },

        isMobileMode: function () {
            let res = this.$vuetify.breakpoint.name === 'xs';
            return res;
        },
        isDesktopMode: function () {
            return !this.isMobileMode();
        },
        refresh: function (self) {
            let momT0 = moment(
                this.configurazione.DATA_APERTURA_ISCRIZIONI,
                'MM/DD/YYYY HH:mm'
            );
            let now = moment(new Date()); //todays date
            let momT1 = moment(
                this.configurazione.DATA_CHIUSURA_ISCRIZIONI,
                'MM/DD/YYYY HH:mm'
            );

            let diff = moment.duration(now - momT0).asMilliseconds();
            let diff2 = moment.duration(now - momT1).asMilliseconds();

            if (diff > 0 && diff2 < 0) {
                this.message = undefined;
                self.getAttivitaGpsEvento(this.raceID, 'durata').then(
                    (response) => {
                        this.showClassifica(response);
                    }
                );
            } else {
                this.message =
                    'I dati saranno visualizzati dal ' +
                    momT0.format('DD/MM/YYYY') +
                    ' al ' +
                    momT1.format('DD/MM/YYYY');
            }
        },
        toggleCompatta() {
            this.compatta = !this.compatta;
        },
        togglePreferiti() {
            this.filterPreferiti = !this.filterPreferiti;
            this.showClassifica(this.raceData);
        },
        toggleItem(pett) {
            if (this.listaPreferiti[pett] == undefined) {
                this.listaPreferiti[pett] = pett;
            } else {
                this.listaPreferiti[pett] = undefined;
            }
            //console.log(pett + '-->' + this.listaPreferiti[pett]);
            helper.ls.set(
                'PREFERITI_' + this.$route.params.raceID,
                this.listaPreferiti
            );
            //this.togglePreferiti();
            //this.togglePreferiti();
            //this.showClassifica(this.raceData);
        },

        gotoMappa(idAttivita, token) {
            console.log(
                'Mappa:' +
                    this.getMappaUrl() +
                    '?idAttivita=' +
                    idAttivita +
                    '&token=' +
                    token
            );
            let _url =
                'https://www.icron.it/virtualdrone/replay/' +
                '?idAttivita=' +
                idAttivita +
                '&token=' +
                token;

            window.open(_url);
            return;

            _url =
                'http://localhost:8082/replay/' +
                '?idAttivita=' +
                idAttivita +
                '&token=' +
                token;
            //window.open("https://www.icron.it/virtualdrone/#/map/" + idAttivita);
        },

        downloadCsv() {
            var listaSearch = this.filteredList();
            var headers = {
                pettorale: 'Pett',
                cognome: 'Cognome',
                nome: 'Nome',
                sesso: 'Sesso',
                squadra: 'Squadra',
                ente: 'Ente',
                categoria: 'Cat',
                tessera: 'Tessera',
            };

            this.exportCSVFile(undefined, this.filteredList()), 'classifica';
        },

        convertToCSV(objArray) {
            var array =
                typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = '';

            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line != '') line += ';';

                    line += array[i][index];
                }

                str += line + '\r\n';
            }

            return str;
        },

        exportCSVFile(headers, items, fileTitle) {
            if (headers) {
                items.unshift(headers);
            }

            // Convert Object to JSON
            var jsonObject = JSON.stringify(items);

            var csv = this.convertToCSV(jsonObject);

            var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

            var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                var link = document.createElement('a');
                if (link.download !== undefined) {
                    // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', exportedFilenmae);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.Cognome != null &&
                        p.Cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.Squadra != null &&
                        p.Squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let resTot = res || res1;
                    return resTot;
                });
            }

            ////console.log('checkpointSelected:' + this.checkpointSelected);

            if (this.categoriaSelected !== 'TUTTE') {
                listaSearch = listaSearch.filter((p) => {
                    var res4 =
                        p != null &&
                        p.categoria != null &&
                        p.categoria == this.categoriaSelected;

                    return res4;
                });
            }

            // //console.log(listaSearch);

            return listaSearch;
        },
    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}
.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}
.frazioniTitleFinale {
    text-align: center;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    font-weight: bold;
}
.cardUp {
    background-color: black;
    color: orange;
    _border: 1px solid lightgray;
    border-radius: 20px 10px 0px 0px;
}
.sticky {
    position: fixed;
    top: 65px;
    z-index: 999;
    width: 100%;
}
.sticky-mobile {
    position: fixed;
    top: 55px;
    z-index: 999;
    width: 100%;
}
</style>